import * as React from 'react';
import { TabTableContainer, Title } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { formatColWithDate, valueGridMoneyFormatter } from '@components/datagrid/custom.datagrid.props';

const columns = [
  { field: 'platform', headerName: 'Platform', width: 132 },
  { field: 'statuss', headerName: 'Status', width: 132 },
  { field: 'item', headerName: 'item', width: 132 },
  { field: 'orderId', headerName: 'Order Id', width: 205 },
  { field: 'currency', headerName: 'Value', width: 160, valueFormatter: valueGridMoneyFormatter },
  { field: 'coins', headerName: 'Value', width: 160, valueFormatter: valueGridMoneyFormatter },
  { field: 'friend', headerName: 'Friend', width: 132 },
  { field: 'settleDate', headerName: 'SettleDate', ...formatColWithDate, width: 150 },
  { field: 'timestamp', headerName: 'Timestamp', ...formatColWithDate, width: 150 },
];

interface PaymentsData {
  paymentId: number;
  cash: number;
  coins: string;
  message: string;
  datee: number;
  name: number;
  collectionDate: string;
}

let index = 0;
function createData(playerPayments: PaymentsData) {
  index += 1;
  return { id: index, ...playerPayments };
}

const PlayerPaymentsList = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<PaymentsData[]>(`/admin/payments/player/${requestPid}`, { params: { page }, cancelToken });
  }
  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });

  const rows = responseData?.map(createData) || [];
  // const rows = responseData || [];

  const total = rows.length;

  return (
    <>
      <TabTableContainer>
        <Title>Payments ({total})</Title>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default PlayerPaymentsList;
